/* Footer Easter egg, homepage only (sections/nr-footer.liquid renders this file
   only there). Five quick taps on the footer logo make it hop, sprout a leaf and
   show the section's "Easter egg line" for a few seconds. On the homepage the
   logo link would only reload the page, so taps are counted instead. */
(function () {
  var link = document.querySelector('[data-nr-egg]');
  var line = document.querySelector('[data-nr-egg-line]');
  var script = document.currentScript || document.querySelector('script[src*="nr-footer-egg"]');
  if (!link || !line || !script) return;
  var text = script.getAttribute('data-text') || '';
  var taps = 0;
  var last = 0;
  var timer;

  link.addEventListener('click', function (event) {
    event.preventDefault();
    var now = Date.now();
    taps = now - last < 1500 ? taps + 1 : 1;
    last = now;
    if (taps < 5) return;
    taps = 0;
    link.classList.remove('is-found');
    void link.offsetWidth;
    link.classList.add('is-found');
    line.textContent = text;
    line.classList.add('is-shown');
    clearTimeout(timer);
    timer = setTimeout(function () {
      link.classList.remove('is-found');
      line.classList.remove('is-shown');
    }, 5000);
  });
})();
